import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { IAtivosModel, IGatewaysModel, IAssociatedIcon } from './types';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Box,
    Button,
    Typography,
    TextField,
    Card,
    CardContent,
    Grid,
    Divider,
    Tabs,
    Tab,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    SelectChangeEvent
} from '@mui/material';
import { useHttpClient, useAlert } from '../../../modules/services/Bundle';
import { RequestMethod } from '../../../modules/services/core/_enums';
import { getDataSetNamePBI } from '../../../modules/services/Bundle';
import { AssetSelector } from './AssetSelector';
import { GatewaySelector } from './GatewaySelector';
import { Tooltip } from '@mui/material';
import { IconPicker } from './IconPicker';
import { MapContainer, TileLayer, GeoJSON } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { Feature } from 'geojson';
import MapBoundsAdjuster from './MapBoundAdjuster';

interface OrganizationData {
    Id: number;
    OrganizationId: number;
    OrganizationName: string;
    CorporationName: string;
    Linhas: number;
    IdOrganizacao: number;
}

interface IPerimetro {
    Id: number;
    IdPlace: number;
    Name: string;
    GeoLocation: any;
}


const EditarOrganizacao: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const httpClient = useHttpClient();
    const alert = useAlert();

    const [organizationData, setOrganizationData] = useState<OrganizationData | null>(null);
    const [linesCount, setLinesCount] = useState<number>(1);
    const [linesInput, setLinesInput] = useState<string>('1');
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [activeSubTab, setActiveSubTab] = useState(0); // NOVO ESTADO PARA AS SUB-ABAS
    const [enrichedAssets, setEnrichedAssets] = useState<IAtivosModel[]>([]);
    const [iconName, setIconName] = useState('');
    const [svgPreview, setSvgPreview] = useState<string | null>(null);
    const ApplicationID = process.env.REACT_APP_ID_APPLICATION;
    const [registeredIcons, setRegisteredIcons] = useState<any[]>([]);
    const [selectedIconId, setSelectedIconId] = useState<number | null>(null);
    const [backendUrl] = useState(process.env.REACT_APP_BACKEND_URL);
    const [iconClass, setIconClass] = useState<string>('');
    const dataSetNamePBI = getDataSetNamePBI();
    const [expandedAccordion, setExpandedAccordion] = useState<string | false>('standard');
    const [isIconPickerOpen, setIconPickerOpen] = useState(false);
    const [iconMap, setIconMap] = useState<Map<number, any>>(new Map());

    // Adicione estes hooks junto com os outros useState no início do componente
    const [assets, setAssets] = useState<IAtivosModel[]>([]);
    const assetTableRef = useRef<HTMLDivElement>(null);
    const assetTabulatorInstance = useRef<any>(null);
    const [selectedAssetIds, setSelectedAssetIds] = useState<number[]>([]);
    const [selectedIconForAssociation, setSelectedIconForAssociation] = useState<number | null>(null);
    const [gateways, setGateways] = useState<IGatewaysModel[]>([]);
    const [enrichedGateways, setEnrichedGateways] = useState<IGatewaysModel[]>([]);
    const [gatewayIconMap, setGatewayIconMap] = useState<Map<number, any>>(new Map());
    const [registeredGatewayIcons, setRegisteredGatewayIcons] = useState<any[]>([]);
    const [selectedGatewayIds, setSelectedGatewayIds] = useState<number[]>([]);
    const [selectedIconForGatewayAssociation, setSelectedIconForGatewayAssociation] = useState<number | null>(null);


    const [locais, setLocais] = useState<any[]>([]);
    const [selectedLocalId, setSelectedLocalId] = useState<string | number>('');
    const [geoJsonString, setGeoJsonString] = useState<string>('');
    const [parsedGeoJson, setParsedGeoJson] = useState<any | null>(null);
    const [mapCenter, setMapCenter] = useState<[number, number]>([-23.57, -46.84]);
    const [nomePerimetro, setNomePerimetro] = useState<string>('');
    const [perimetrosCadastrados, setPerimetrosCadastrados] = useState<IPerimetro[]>([]);
    const [selectedPerimetroId, setSelectedPerimetroId] = useState<number | null>(null);
    const [mapInitialCenter] = useState<[number, number]>([-23.57, -46.84]);
    const initialZoom = 13;
  

    const [standardIcons, setStandardIcons] = useState([
        { name: 'pets', label: 'Boi' },
        { name: 'directions_car', label: 'Carro' },
        { name: 'agriculture', label: 'Trator' },
        { name: 'apartment', label: 'Prédio' },
        { name: 'desktop_windows', label: 'Monitor' },
    ]);


    useEffect(() => {
        try {
            const cachedIcons = localStorage.getItem('customStandardIcons');
            if (cachedIcons) {
                const parsedIcons = JSON.parse(cachedIcons);
                // Evita duplicados ao juntar com os ícones iniciais
                const initialNames = standardIcons.map(i => i.name);
                const uniqueNewIcons = parsedIcons.filter((i: any) => !initialNames.includes(i.name));
                setStandardIcons(prevIcons => [...prevIcons, ...uniqueNewIcons]);
            }
        } catch (error) {
            console.error("Falha ao carregar ícones do cache:", error);
        }
    }, []);


    // Recuperar dados da organização dos parâmetros da URL
    useEffect(() => {
        console.log('useEffect executado - searchParams:', searchParams.get('data'));
        const orgDataParam = searchParams.get('data');
        if (orgDataParam) {
            try {
                const data = JSON.parse(decodeURIComponent(orgDataParam));
                console.log('Dados da organização carregados:', data);
                setOrganizationData(data);
                setLinesCount(data.Linhas || 1);
                setLinesInput(String(data.Linhas || 1));
                console.log('linesInput setado para:', String(data.Linhas || 1));
            } catch (error) {
                console.error('Erro ao parsear dados da organização:', error);
                alert.createMessage({
                    type: 'error',
                    message: 'Erro ao carregar dados da organização'
                });
                navigate('/administracao/Menu-Orgs');
            }
        } else {
            alert.createMessage({
                type: 'error',
                message: 'Dados da organização não encontrados'
            });
            navigate('/administracao/Menu-Orgs');
        }
    }, [searchParams]);

    useEffect(() => {
        if (assets.length > 0) {
            const newEnrichedAssets = assets.map(asset => ({
                ...asset,
                associatedIcon: iconMap.get(asset.IdPrism) || null,
            }));
            setEnrichedAssets(newEnrichedAssets);
            console.log('Enriched Assets passed to AssetSelector:', enrichedAssets)
        } else {
            setEnrichedAssets([]);
        }
    }, [assets, iconMap]);

    useEffect(() => {
        if (gateways.length > 0) {
            const newEnrichedGateways = gateways.map(gateway => ({
                ...gateway,
                associatedIcon: gatewayIconMap.get(gateway.IdGateway) || null
            }));

            // --- ADICIONADO PARA DEPURAÇÃO ---
            console.log("--- Enriquecimento de Gateways ---");
            console.log("Mapa de Ícones de Gateway utilizado:", gatewayIconMap);
            console.log("Resultado final (enrichedGateways):", newEnrichedGateways);
            console.log("---------------------------------");
            // --------------------------------

            setEnrichedGateways(newEnrichedGateways);
        } else {
            setEnrichedGateways([]);
        }
    }, [gateways, gatewayIconMap]);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    const handleSubTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveSubTab(newValue);
    };

    const handleAccordionChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpandedAccordion(isExpanded ? panel : false);
        // Limpa o outro campo para evitar confusão
        if (isExpanded) {
            if (panel === 'standard') {
                setSvgPreview('');
            } else if (panel === 'custom') {
                setIconClass('');
                setIconName('');
            }
        }
    };

    const handleAssetSelectionChange = useCallback((selectedAssetObjects: IAtivosModel[]) => {
        const ids = selectedAssetObjects.map(asset => asset.IdAtivo);
        setSelectedAssetIds(ids);
    }, []);
    const handleGatewaySelectionChange = useCallback((selectedGatewayObjects: IGatewaysModel[]) => {
        const ids = selectedGatewayObjects.map(gateway => gateway.IdGateway);
        setSelectedGatewayIds(ids);
    }, []);

    const handleLinesInputChange = (value: string) => {
        console.log('handleLinesInputChange chamado com valor:', value);


        const numericValue = value.replace(/[^0-9]/g, '');
        console.log('Valor numérico filtrado:', numericValue);
        setLinesInput(numericValue);
        console.log('linesInput deve ser setado para:', numericValue);
    };

    const handleLinesInputBlur = () => {
        if (linesInput === '' || linesInput === '0') {
            setLinesCount(1);
            setLinesInput('1');
            return;
        }

        const numValue = parseInt(linesInput);
        if (isNaN(numValue) || numValue < 1) {
            setLinesCount(1);
            setLinesInput('1');
        } else if (numValue > 100) {
            setLinesCount(100);
            setLinesInput('100');
        } else {
            setLinesCount(numValue);
            setLinesInput(String(numValue));
        }
    };

    const handleSave = async () => {
        if (!organizationData) return;

        // Aplicar validação antes de salvar
        handleLinesInputBlur();

        setLoading(true);
        try {
            const response = await httpClient.request({
                method: RequestMethod.PUT,
                endpoint: '/api/LinhasMovimentacoesAtivos',
                data: {
                    Id: organizationData.Id,
                    Linhas: linesCount,
                    IdOrganizacao: organizationData.IdOrganizacao || organizationData.OrganizationId
                }
            });

            if (response.success) {
                alert.createMessage({
                    icon: 'success',
                    title: 'Sucesso',
                    message: 'Configurações salvas com sucesso!'
                });
                navigate('/administracao/Menu-Orgs');
            } else {
                throw new Error((response as any).message || 'Erro ao salvar configurações');
            }
        } catch (error) {
            alert.createMessage({
                icon: 'error',
                title: 'Erro ao salvar',
                message: (error instanceof Error ? error.message : 'Erro ao salvar configurações')
            });
        } finally {
            setLoading(false);
        }
    };




    const handleIconSelectFromPicker = (iconName: string) => {
        setIconName(iconName);
        setIconClass(iconName);
        setSvgPreview('');
        const isAlreadyInList = standardIcons.some(icon => icon.name === iconName);
        if (!isAlreadyInList) {
            const newIcon = { name: iconName, label: iconName };
            const updatedIcons = [...standardIcons, newIcon];
            setStandardIcons(updatedIcons);

            // 3. Salva a lista atualizada no cache do navegador
            try {
                const cachedIcons = JSON.parse(localStorage.getItem('customStandardIcons') || '[]');
                const updatedCache = [...cachedIcons, newIcon];
                localStorage.setItem('customStandardIcons', JSON.stringify(updatedCache));
            } catch (error) {
                console.error("Falha ao salvar ícones no cache:", error);
            }
        }
    };


    const handleDeleteIcon = async () => {
        if (!selectedIconId) return;
        if (!window.confirm('Tem certeza que deseja deletar este ícone?')) return;
        setLoading(true);
        try {
            const response = await httpClient.request({
                method: RequestMethod.DELETE,
                endpoint: `/api/TagPrism/${selectedIconId}`,
            });
            console.log('Response from delete icon:', response);
            if (response.success) {
                alert.createMessage({
                    icon: 'success',
                    title: 'Sucesso',
                    message: 'Ícone deletado com sucesso!'
                });
                setIconName('');
                setSvgPreview('');
                setSelectedIconId(null);
                await fetchIcons();
                setRegisteredIcons(prev =>
                    prev.filter(icon => icon.Id !== selectedIconId)
                );
            } else {
                throw new Error((response as any).message || 'Erro ao deletar o ícone');
            }
        } catch (error) {
            alert.createMessage({
                icon: 'error',
                title: 'Erro ao deletar',
                message: (error instanceof Error ? error.message : `Erro ao deletar o ícone ${iconName}`)
            });
        } finally {
            setLoading(false);
        }
    };



    const fetchAssets = async () => {
        if (!organizationData) return;

        setLoading(true);
        try {
            const endpoint = '/Gerenciamento/PowerBI/ObterAtivosByOrg';
            const queryParams = new URLSearchParams();
            if (dataSetNamePBI) {
                queryParams.append('datasetName', dataSetNamePBI);
            }
            if (organizationData.OrganizationId) {
                queryParams.append('organization', organizationData.OrganizationName);
            }
            const fullUrl = `${endpoint}?${queryParams.toString()}`;

            const response = await httpClient.request({
                method: RequestMethod.GET,
                endpoint: fullUrl,
            });

            if (response.success && response.payload) {
                setAssets(Array.isArray(response.payload) ? response.payload : []);
            } else {
                throw new Error((response as any).message || 'Erro ao buscar ativos');
            }
        } catch (error) {
            alert.createMessage({
                icon: 'error',
                title: 'Erro ao carregar ativos',
                message: (error instanceof Error ? error.message : 'Erro ao carregar ativos')
            });
            setAssets([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchIconsForAssets = async () => {
            if (assets.length === 0) {
                setIconMap(new Map());
                return;
            }

            try {
                const assetIds = assets.map(asset => asset.IdPrism);
                const requestBody = {
                    IdsPrism: assetIds,
                    IdApp: process.env.REACT_APP_POWER_BI_APPLICATIONID
                };

                // 1. Usando a API 'fetch' em vez do 'httpClient' problemático.
                const response = await fetch(`${backendUrl}/api/PrismTags/by-idsprism`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestBody)
                });

                if (!response.ok) {
                    throw new Error(`Erro na rede: ${response.statusText}`);
                }

                // 2. Convertendo a resposta para JSON.
                const parsedResponse = await response.json(); // Ex: { Data: [...] }
                console.log("DEBUG 1: Resposta da API de ícones (com fetch):", parsedResponse);

                // 3. Extraindo o array da propriedade 'Data', como o backend retorna.
                const iconDataArray = parsedResponse.Data;

                if (Array.isArray(iconDataArray)) {
                    const newIconMap = new Map<number, any>();

                    iconDataArray.forEach((assoc: any) => {
                        if (assoc && assoc.IdPrism != null) {
                            let processedIconData = { ...assoc };
                            if (typeof processedIconData.Value === 'string') {
                                try {
                                    processedIconData.Value = JSON.parse(processedIconData.Value);
                                } catch (e) {
                                    processedIconData.Value = {};
                                }
                            }
                            newIconMap.set(processedIconData.IdPrism, processedIconData);
                        }
                    });

                    console.log("DEBUG 2: Mapa de ícones construído:", newIconMap);
                    setIconMap(newIconMap);
                } else {
                    console.warn("A propriedade 'Data' na resposta não é um array.", parsedResponse);
                    setIconMap(new Map());
                }

            } catch (error) {
                console.error("Falha ao buscar ícones associados:", error);
                setIconMap(new Map());
            }
        };

        fetchIconsForAssets();
    }, [assets]);

    const handleAssociateIcon = async () => {
        if (selectedAssetIds.length === 0 && !selectedIconForAssociation) {
            alert.createMessage({
                icon: 'warning',
                title: 'Atenção',
                message: 'Selecione ao menos um ativo e um ícone para fazer a associação.'
            });
            return;
        }
        setLoading(true);

        try {
            const payload = {
                IdPrism: selectedAssetIds,
                IdTagPrism: selectedIconForAssociation,
            };

            const response = await httpClient.request({
                method: RequestMethod.POST,
                endpoint: `/api/PrismTags?idApplication=${process.env.REACT_APP_POWER_BI_APPLICATIONID}`,
                data: payload,
            });

            if (response.success) {
                alert.createMessage({
                    icon: 'success',
                    title: `${selectedAssetIds.length} ativo(s) foram associados ao ícone com sucesso.`,
                });

                setSelectedAssetIds([]);
                setSelectedIconForAssociation(null);
                fetchAssets();
            } else {
                const errorMessage = 'Falha ao associar o ícone aos ativos.';
                throw new Error(errorMessage);
            }

        } catch (error) {
            alert.createMessage({
                icon: 'error',
                title: 'Erro ao associar ícones',
            });
        } finally {
            setLoading(false);
        }
    };



    const fetchIcons = async () => {
        if (!organizationData) return;
        try {
            const response = await fetch(
                `${backendUrl}/api/TagPrism/organization/${organizationData.OrganizationId}/application/${process.env.REACT_APP_POWER_BI_APPLICATIONID}`
            );
            const data = await response.json();
            if (Array.isArray(data)) {
                // Parse o Value se for string
                const parsed = data.map((icon) => ({
                    ...icon,
                    Value: typeof icon.Value === 'string'
                        ? JSON.parse(icon.Value)
                        : icon.Value
                }));
                setRegisteredIcons(parsed);
            }
        } catch (error) {
            alert.createMessage({
                icon: 'error',
                title: 'Erro ao carregar ícones',
                message: 'Erro ao carregar ícones'
            });
        }
    };



    // ===================================================
    // ===== INÍCIO DAS FUNÇÕES DE API PARA GATEWAYS =====
    // ===================================================

    const fetchGateways = async () => {
        if (!organizationData) return;

        setLoading(true);
        try {
            const endpoint = '/Gerenciamento/PowerBI/ObterGatewaysByOrg';
            const queryParams = new URLSearchParams();
            if (dataSetNamePBI) {
                queryParams.append('datasetName', dataSetNamePBI);
            }
            if (organizationData.OrganizationId) {
                queryParams.append('organization', organizationData.OrganizationName);
            }
            const fullUrl = `${endpoint}?${queryParams.toString()}`;

            const response = await httpClient.request({
                method: RequestMethod.GET,
                endpoint: fullUrl,
            });

            if (response.success && response.payload) {
                setGateways(Array.isArray(response.payload) ? response.payload : []);
            } else {
                throw new Error((response as any).message || 'Erro ao buscar gateways');
            }
        } catch (error) {
            alert.createMessage({
                icon: 'error',
                title: 'Erro ao carregar gateways',
                message: (error instanceof Error ? error.message : 'Erro ao carregar gateways')
            });
            setGateways([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchGatewayIcons = async () => {
        if (!organizationData) return;
        try {
            const response = await fetch(`${backendUrl}/api/TagPlace/organization/${organizationData.OrganizationId}/application/${process.env.REACT_APP_POWER_BI_APPLICATIONID}`);
            const data = await response.json();
            if (Array.isArray(data)) {
                const parsed = data.map((icon) => ({ ...icon, Value: typeof icon.Value === 'string' ? JSON.parse(icon.Value) : icon.Value }));
                setRegisteredGatewayIcons(parsed);
            }
        } catch (error) {
            console.error("Falha ao carregar ícones de gateway:", error);
        }
    };

    const fetchIconsForGateways = async (currentGateways: IGatewaysModel[]) => {
        if (!currentGateways || currentGateways.length === 0) {
            setGatewayIconMap(new Map());
            return;
        }
        try {
            const placeIds = currentGateways.map(gateway => gateway.IdGateway);
            const response = await fetch(`${backendUrl}/api/PlaceTags/by-idsplace`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ IdsPlaces: placeIds, IdApp: process.env.REACT_APP_POWER_BI_APPLICATIONID })
            });
            const parsedResponse = await response.json();

            if (Array.isArray(parsedResponse.Data)) {
                const newIconMap = new Map<number, IAssociatedIcon>();

                parsedResponse.Data.forEach((assoc: any) => {
                    // INÍCIO DA LÓGICA CORRIGIDA
                    if (assoc && assoc.IdPlace != null) {
                        try {
                            const valueObject = JSON.parse(assoc.Value);
                            const iconDetails: IAssociatedIcon = {
                                IdPlace: assoc.IdPlace,
                                Name: assoc.Name,
                                Description: assoc.Description,
                                Codigo: assoc.Codigo,
                                Value: valueObject
                            };

                            newIconMap.set(assoc.IdPlace, iconDetails);

                        } catch (e) {
                            console.error('Falha ao processar o campo "Value" do ícone associado:', assoc);
                        }
                    }
                });

                console.log("Mapa de ícones de Gateway construído com sucesso:", newIconMap);
                setGatewayIconMap(newIconMap);
            }
        } catch (error) {
            console.error("Falha ao buscar ícones associados a gateways:", error);
        }
    };

    const handleGatewayIconUpload = async () => {
        if (!organizationData || !iconName.trim()) return;
        const payload = {
            Id: selectedIconId || undefined,
            IdOrganization: organizationData.OrganizationId,
            IdApplication: process.env.REACT_APP_POWER_BI_APPLICATIONID,
            Codigo: "Icone " + iconName.trim(),
            Name: iconName,
            Description: `Ícone de Gateway para ${organizationData.OrganizationName}`,
            Value: { SVG: svgPreview?.trim() || "", Class: iconClass }
        };
        const response = await httpClient.request({
            method: selectedIconId ? RequestMethod.PUT : RequestMethod.POST,
            endpoint: selectedIconId ? `/api/TagPlace/${selectedIconId}` : `/api/TagPlace`,
            data: payload
        });
        if (response.success) {
            alert.createMessage({ icon: 'success', title: 'Sucesso!', message: `Ícone ${selectedIconId ? 'atualizado' : 'cadastrado'} com sucesso.` });
            await fetchGatewayIcons();
        }
    };

    const handleDeleteGatewayIcon = async () => {
        if (!selectedIconId || !window.confirm('Tem certeza?')) return;
        const response = await httpClient.request({ method: RequestMethod.DELETE, endpoint: `/api/TagPlace/${selectedIconId}` });
        if (response.success) {
            alert.createMessage({ icon: 'success', title: 'Sucesso!', message: 'Ícone deletado.' });
            await fetchGatewayIcons();
        }
    };

    const handleAssociateGatewayIcon = async () => {
        if (selectedGatewayIds.length === 0 || !selectedIconForGatewayAssociation) return;
        const payload = { IdPlace: selectedGatewayIds, IdTagPlace: selectedIconForGatewayAssociation };
        const response = await httpClient.request({
            method: RequestMethod.POST,
            endpoint: `/api/PlaceTags?idApplication=${process.env.REACT_APP_POWER_BI_APPLICATIONID}`,
            data: payload
        });
        if (response.success) {
            alert.createMessage({ icon: 'success', title: 'Sucesso!', message: 'Ícone(s) associado(s).' });
            await fetchIconsForGateways(gateways);
        }
    };

    // ===================================================
    // ===== FIM DAS FUNÇÕES DE API PARA GATEWAYS =====
    // ===================================================

    // ===================================================
    // ===== INÍCIO DAS FUNÇÕES PARA ABA DE LOCAIS =====
    // ===================================================

    const fetchLocais = async () => {
        // Sai se organizationData ou auth token não estiverem prontos
        if (!organizationData) {
            console.log("fetchLocais: organizationData ou auth.Token indisponível.");
            setLocais([]); // Garante que a lista esteja vazia
            setPerimetrosCadastrados([]);
            return;
        }

        const orgId = organizationData.OrganizationId;
        const endpoint = `${backendUrl}/api/Place/ByOrg?orgId=${orgId}`; // backendUrl deve estar definido

        console.log(`fetchLocais: Buscando locais via fetch para orgId=${orgId}`);
        setLoading(true);
        // Limpa estados antes da busca
        setLocais([]);
        setPerimetrosCadastrados([]);

        try {
            const response = await fetch(endpoint, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });

            if (!response.ok) {
                const errorText = await response.text().catch(() => 'Erro ao ler corpo da resposta'); // Tenta ler o corpo do erro
                console.error(`Erro HTTP ${response.status} ao buscar locais: ${response.statusText}`, errorText);
                throw new Error(`Erro HTTP: ${response.status}`);
            }
            const data = await response.json();
            if (Array.isArray(data)) {
                console.log(`fetchLocais: ${data.length} locais recebidos via fetch com sucesso.`);
                setLocais(data);
                if (data.length === 0) {
                    setPerimetrosCadastrados([]);
                }
            } else {
                console.error("fetchLocais: A resposta da API via fetch não foi um array:", data);
                setLocais([]);
                setPerimetrosCadastrados([]);
            }

        } catch (error) {
            console.error("Erro na função fetchLocais:", (error instanceof Error ? error.message : 'Erro desconhecido'));
            setLocais([]);
            setPerimetrosCadastrados([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchPerimetros = async (idPlaces: (number | string)[]) => {
        if (!idPlaces || idPlaces.length === 0) {
            if (perimetrosCadastrados.length > 0) {
                setPerimetrosCadastrados([]);
            }
            return;
        }

        const endpoint = `${backendUrl}/api/PlaceGeometry/ByIdPlaces`; // backendUrl deve estar definido

        console.log(`fetchPerimetros: Buscando perímetros para ${idPlaces.length} locais via fetch.`);
        setLoading(true);

        try {
            const response = await fetch(endpoint, {
                method: 'POST', // Método POST
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(idPlaces)
            });


            if (!response.ok) {
                const errorText = await response.text().catch(() => 'Erro ao ler corpo da resposta');
                console.error(`Erro HTTP ${response.status} ao buscar perímetros: ${response.statusText}`, errorText);
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const data = await response.json();

            if (Array.isArray(data)) {
                console.log(`fetchPerimetros: ${data.length} perímetros recebidos via fetch com sucesso.`);
                setPerimetrosCadastrados(data);
            } else {

                console.error("fetchPerimetros: A resposta da API via fetch não foi um array:", data);
                setPerimetrosCadastrados([]);
            }

        } catch (error) {
            console.error("Erro na função fetchPerimetros:", (error instanceof Error ? error.message : 'Erro desconhecido'));
            setPerimetrosCadastrados([]);
        } finally {
            setLoading(false);
        }
    };



    const handleCreatePerimetro = async () => {
        if (!selectedLocalId || !nomePerimetro.trim() || !parsedGeoJson) {
            alert.createMessage({
                icon: 'warning',
                title: 'Atenção',
                message: 'Por favor, selecione um local, forneça um nome e um GeoJSON válido.'
            });
            return;
        }

        setLoading(true);
        let geometriaParaEnviar = parsedGeoJson;
        if (parsedGeoJson.type === "Feature" && parsedGeoJson.geometry) {
            geometriaParaEnviar = parsedGeoJson.geometry;
        }

        const payload = {
            IdPlace: selectedLocalId,
            Name: nomePerimetro,  // <-- NOVO
            GeoLocation: geometriaParaEnviar
        };

        try {
            const response = await httpClient.request({
                method: RequestMethod.POST,
                endpoint: '/api/PlaceGeometry',
                data: payload
            });

            if (response.success) {
                alert.createMessage({
                    icon: 'success',
                    title: 'Sucesso!',
                    message: 'Perímetro cadastrado com sucesso.'
                });
                handleLimparFormulario(); // Limpa o formulário
                // Atualiza a lista de perímetros
                if (selectedLocalId) {
                    fetchPerimetros([selectedLocalId]);
                } else if (locais.length > 0) {
                    fetchPerimetros(locais.map(l => l.Id));
                }
            } else {
                throw new Error((response as any).message || 'Erro ao salvar geometria');
            }
        } catch (error) {
            alert.createMessage({
                icon: 'error',
                title: 'Erro ao salvar',
                message: (error instanceof Error ? error.message : 'Erro ao salvar geometria')
            });
        } finally {
            setLoading(false);
        }
    };

    // NOVA FUNÇÃO: Update (PATCH/PUT)
    const handleUpdatePerimetro = async () => {
        if (!selectedPerimetroId || !selectedLocalId || !nomePerimetro.trim() || !parsedGeoJson) {
            alert.createMessage({
                icon: 'warning',
                title: 'Atenção',
                message: 'Um perímetro deve estar selecionado e todos os campos preenchidos para atualizar.'
            });
            return;
        }

        if (!window.confirm(`Tem certeza que deseja ATUALIZAR o perímetro "${nomePerimetro}"?`)) return;

        setLoading(true);
        let geometriaParaEnviar = parsedGeoJson;
        if (parsedGeoJson.type === "Feature" && parsedGeoJson.geometry) {
            geometriaParaEnviar = parsedGeoJson.geometry;
        }

        // VERIFIQUE ESTE PAYLOAD!
        // Assumindo que a API de UPDATE precisa do ID do *perímetro*
        const payload = {
            Id: selectedPerimetroId,
            IdPlace: selectedLocalId,
            Name: nomePerimetro,
            GeoLocation: geometriaParaEnviar
        };

        try {
            const response = await httpClient.request({
                method: RequestMethod.PATCH,
                endpoint: `/api/PlaceGeometry/${selectedPerimetroId}`,
                data: payload
            });

            if (response.success) {
                alert.createMessage({
                    icon: 'success',
                    title: 'Sucesso!',
                    message: 'Perímetro atualizado com sucesso.'
                });
                handleLimparFormulario();
                // Atualiza a lista de perímetros
                if (selectedLocalId) {
                    fetchPerimetros([selectedLocalId]);
                } else if (locais.length > 0) {
                    fetchPerimetros(locais.map(l => l.Id));
                }
            } else {
                throw new Error((response as any).message || 'Erro ao atualizar geometria');
            }
        } catch (error) {
            alert.createMessage({
                icon: 'error',
                title: 'Erro ao atualizar',
                message: (error instanceof Error ? error.message : 'Erro ao atualizar geometria')
            });
        } finally {
            setLoading(false);
        }
    };

    // NOVA FUNÇÃO: Delete
    const handleDeletePerimetro = async () => {
        if (!selectedPerimetroId) {
            alert.createMessage({
                icon: 'warning',
                title: 'Atenção',
                message: 'Nenhum perímetro selecionado para deletar.'
            });
            return;
        }

        if (!window.confirm(`Tem certeza que deseja DELETAR o perímetro "${nomePerimetro}"? Esta ação não pode ser desfeita.`)) return;

        setLoading(true);
        try {
            // VERIFIQUE ESTE ENDPOINT!
            // Assumindo endpoint DELETE /api/PlaceGeometry/{id}
            const response = await httpClient.request({
                method: RequestMethod.DELETE,
                endpoint: `/api/PlaceGeometry/${selectedPerimetroId}`,
            });

            if (response.success) {
                alert.createMessage({
                    icon: 'success',
                    title: 'Sucesso!',
                    message: 'Perímetro deletado com sucesso.'
                });
                handleLimparFormulario();
                // Atualiza a lista de perímetros
                setPerimetrosCadastrados(prev => prev.filter(p => p.Id !== selectedPerimetroId));
            } else {
                throw new Error((response as any).message || 'Erro ao deletar geometria');
            }
        } catch (error) {
            alert.createMessage({
                icon: 'error',
                title: 'Erro ao deletar',
                message: (error instanceof Error ? error.message : 'Erro ao deletar geometria')
            });
        } finally {
            setLoading(false);
        }
    };

    // ===================================================
    // ===== FIM DAS FUNÇÕES PARA ABA DE LOCAIS ========
    // ===================================================

    useEffect(() => {
        if (!organizationData) return;
        setIconName('');
        setSvgPreview(null);
        setIconClass('');
        setSelectedIconId(null);

        if (activeTab === 1) {
            fetchIcons();
            if (activeSubTab === 1) {
                fetchAssets();
            }
        } else if (activeTab === 2) {
            fetchGatewayIcons();
            if (activeSubTab === 1) {
                fetchGateways();
            }
        } else if (activeTab === 3) {
            handleLimparFormulario();
            fetchLocais();
        }
    }, [activeTab, activeSubTab, organizationData]);



    useEffect(() => { if (assets.length > 0) fetchIcons(); }, [assets]);
    useEffect(() => { if (gateways.length > 0) fetchIconsForGateways(gateways); }, [gateways]);

    useEffect(() => {
        if (!geoJsonString) {
            setParsedGeoJson(null);
            return;
        }
        try {
            const json = JSON.parse(geoJsonString);

            let geometry: any | null = null;
            let geoJsonParaMapa: any | null = null;

            if (json.type === "FeatureCollection" && Array.isArray(json.features) && json.features.length > 0) {
                const firstFeature = json.features[0];
                if (firstFeature && firstFeature.type === "Feature" && firstFeature.geometry) {
                    geometry = firstFeature.geometry;
                    geoJsonParaMapa = geometry;
                }
            }
            // Caso 2: É uma Feature única?
            else if (json.type === "Feature" && json.geometry) {
                geometry = json.geometry;
                geoJsonParaMapa = geometry;
                console.log("GeoJSON: Extraído geometry de Feature única.");
            }
            else if (json.type === "Polygon" || json.type === "MultiPolygon") {
                geometry = json;
                geoJsonParaMapa = geometry;
            }

            if (geometry && (geometry.type === "Polygon" || geometry.type === "MultiPolygon") && geometry.coordinates) {
                setParsedGeoJson(geoJsonParaMapa);

                // Tenta centralizar o mapa
                let coords = null;
                if (geometry.type === "Polygon") {
                    if (geometry.coordinates && geometry.coordinates[0] && geometry.coordinates[0][0]) {
                        coords = geometry.coordinates[0][0];
                    }
                } else if (geometry.type === "MultiPolygon") {
                    if (geometry.coordinates && geometry.coordinates[0] && geometry.coordinates[0][0] && geometry.coordinates[0][0][0]) {
                        coords = geometry.coordinates[0][0][0];
                    }
                }

                if (Array.isArray(coords) && coords.length === 2 && !isNaN(coords[1]) && !isNaN(coords[0])) {
                    setMapCenter([coords[1], coords[0]]);
                } else {
                    console.warn("GeoJSON: Não foi possível extrair coordenadas válidas para centralizar o mapa.");
                }

            } else {
                console.warn("GeoJSON: Formato inválido ou não contém geometria Polygon/MultiPolygon com coordenadas.");
                setParsedGeoJson(null);
            }
        } catch (error) {
            console.error("GeoJSON: Erro ao parsear JSON:", error);
            setParsedGeoJson(null);
        }
    }, [geoJsonString]);

    useEffect(() => {
        if (activeTab !== 3 || !locais || locais.length === 0) {
            setPerimetrosCadastrados([]);
            return;
        }

        if (selectedLocalId) {
            fetchPerimetros([selectedLocalId]);
        } else {
            const allPlaceIds = locais.map(l => l.Id);
            fetchPerimetros(allPlaceIds);
        }

    }, [locais, selectedLocalId, activeTab]);


    const handleIconUpload = async () => {
        if (!organizationData || !iconName.trim() ||
            (!svgPreview?.trim() && !iconClass?.trim())) {
            alert.createMessage({
                icon: 'error',
                title: 'Preencha todos os campos obrigatórios: Nome do Ícone e SVG.'
            });
            return;
        }

        try {
            const payload = {
                Id: selectedIconId || undefined, // se for update, envie o Id
                IdOrganization: organizationData.OrganizationId,
                IdApplication: process.env.REACT_APP_POWER_BI_APPLICATIONID,
                Codigo: "Icone " + iconName.trim(),
                Name: iconName,
                Description: `Ícone personalizado para ${organizationData.OrganizationName} - ${iconName.trim()}`,
                Value: {
                    SVG: svgPreview?.trim() || "",
                    Class: iconClass
                }
            };

            const response = await httpClient.request({
                method: selectedIconId ? RequestMethod.PUT : RequestMethod.POST,
                endpoint: selectedIconId ? `/api/TagPrism/${selectedIconId}` : `/api/TagPrism`,
                data: payload
            });
            console.log('Response from icon upload:', response);
            if (response.success) {
                alert.createMessage({
                    icon: 'success',
                    title: selectedIconId ? 'Ícone atualizado com sucesso!' : 'Ícone cadastrado com sucesso!'
                });
                setIconName('');
                setSvgPreview('');
                setSelectedIconId(null);
                await fetchIcons();
            }
        } catch (error) {
            alert.createMessage({
                icon: 'error',
                title: 'Erro',
                message: (error instanceof Error ? error.message : 'Erro ao cadastrar o ícone')
            });
        }
    };


    // ===================================================
    // ===== Funções de Callback do Mapa (NOVAS) =====
    // ===================================================

    // Chamado ao clicar em um perímetro no mapa
    const handlePerimetroClick = (perimetro: IPerimetro) => {
        setSelectedPerimetroId(perimetro.Id);
        setNomePerimetro(perimetro.Name);
        setSelectedLocalId(perimetro.IdPlace);
        setGeoJsonString(JSON.stringify(perimetro.GeoLocation, null, 2));
    };
    const onEachPerimetro = (feature: Feature, layer: L.Layer) => {
        const perimetroProps = feature.properties as IPerimetro;

        layer.bindPopup(`<b>${perimetroProps.Name}</b>`);
        layer.on({
            click: () => {
                const perimetroCompleto = perimetrosCadastrados.find(p => p.Id === perimetroProps.Id);
                if (perimetroCompleto) {
                    handlePerimetroClick(perimetroCompleto);
                }
            }
        });
    };

    // Constrói o GeoJSON FeatureCollection para o mapa
    const perimetrosFeatureCollection = {
        type: "FeatureCollection",
        // Transforma a lista de perímetros da API em Features GeoJSON
        features: perimetrosCadastrados.map(p => ({
            type: "Feature",
            geometry: p.GeoLocation, // A API deve retornar a geometria aqui
            properties: {
                Id: p.Id,
                IdPlace: p.IdPlace,
                Name: p.Name
            }
        }))
    };

    // NOVA FUNÇÃO: Limpar formulário de locais
    const handleLimparFormulario = () => {
        setSelectedPerimetroId(null);
        setSelectedLocalId('');
        setNomePerimetro('');
        setGeoJsonString('');
        setParsedGeoJson(null);
    };


    if (!organizationData) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <Typography>Carregando...</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ p: 3 }}>
            <Card>
                <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                        <Typography variant="h6" component="h2">
                            {organizationData.CorporationName} - {organizationData.OrganizationName}
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Button variant="outlined" onClick={() => navigate('/administracao/Menu-Orgs')} disabled={loading}>
                                Voltar
                            </Button>
                            {activeTab === 0 && (
                                <Button variant="contained" onClick={handleSave} disabled={loading}>
                                    {loading ? 'Salvando...' : 'Salvar'}
                                </Button>
                            )}
                            {activeTab === 1 && activeSubTab === 0 && (
                                <>
                                    {selectedIconId && (
                                        <Button variant="outlined" color="error" onClick={handleDeleteIcon} disabled={loading}>
                                            {loading ? 'Deletando...' : 'Deletar'}
                                        </Button>
                                    )}
                                    <Button
                                        variant="contained"
                                        onClick={handleIconUpload}
                                        disabled={!iconName.trim() || (!svgPreview?.trim() && !iconClass?.trim()) || loading}
                                    >
                                        {loading ? 'Enviando...' : (selectedIconId ? 'Atualizar Ícone' : 'Cadastrar Ícone')}
                                    </Button>
                                </>
                            )}
                            {activeTab === 1 && activeSubTab === 1 && (
                                <Button
                                    variant="contained"
                                    onClick={handleAssociateIcon}
                                    disabled={selectedAssetIds.length === 0 || !selectedIconForAssociation || loading}
                                >
                                    {loading ? 'Associando...' : 'Associar Ícone'}
                                </Button>
                            )}
                            {activeTab === 2 && activeSubTab === 0 && (
                                <>
                                    {selectedIconId && (
                                        <Button variant="outlined" color="error" onClick={handleDeleteGatewayIcon} disabled={loading}>
                                            {loading ? 'Deletando...' : 'Deletar'}
                                        </Button>
                                    )}
                                    <Button
                                        variant="contained"
                                        onClick={handleGatewayIconUpload}
                                        disabled={!iconName.trim() || (!svgPreview?.trim() && !iconClass?.trim()) || loading}
                                    >
                                        {loading ? 'Enviando...' : (selectedIconId ? 'Atualizar Ícone' : 'Cadastrar Ícone')}
                                    </Button>
                                </>
                            )}
                            {activeTab === 2 && activeSubTab === 1 && (
                                <Button
                                    variant="contained"
                                    onClick={handleAssociateGatewayIcon}
                                    disabled={selectedGatewayIds.length === 0 || !selectedIconForGatewayAssociation || loading}
                                >
                                    {loading ? 'Associando...' : 'Associar Ícone'}
                                </Button>
                            )}
                        </Box>
                    </Box>

                    <Divider sx={{ my: 3 }} />

                    {/* O resto do seu <CardContent> (Abas, etc.) continua aqui... */}

                    {/* ==================================================================== */}
                    {/* ===== INÍCIO DA SEÇÃO DE NAVEGAÇÃO PRINCIPAL DAS ABAS (ALTERADA) ===== */}
                    {/* ==================================================================== */}
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={activeTab} onChange={handleTabChange} aria-label="configurações tabs">
                            <Tab label="Configurações Gerais" />
                            <Tab label="Configuração de Ativo" />
                            <Tab label="Configuração dos Gateways" />
                            <Tab label="Configuração de Locais" />
                        </Tabs>
                    </Box>
                    {/* ================================================================== */}
                    {/* ===== FIM DA SEÇÃO DE NAVEGAÇÃO PRINCIPAL DAS ABAS (ALTERADA) ===== */}
                    {/* ================================================================== */}


                    {/* Tab Panels */}

                    {/* ========================================================== */}
                    {/* ===== INÍCIO DO PAINEL DA ABA "CONFIGURAÇÕES GERAIS" ===== */}
                    {/* ========================================================== */}
                    {activeTab === 0 && (
                        <Box sx={{ py: 3 }}>
                            <Typography variant="h6" gutterBottom>
                                Configuração de Linhas de Movimentação
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                Defina o número de linhas de movimentos para esta organização
                            </Typography>

                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Número de Linhas"
                                        value={linesInput}
                                        onChange={(e) => {
                                            console.log('TextField onChange - e.target.value:', e.target.value);
                                            console.log('linesInput atual antes da mudança:', linesInput);
                                            handleLinesInputChange(e.target.value);
                                        }}
                                        onBlur={handleLinesInputBlur}
                                        helperText="Mínimo: 1 linha, Máximo: 100 linhas"
                                        placeholder="Digite o número de linhas"
                                    />
                                </Grid>
                            </Grid>


                        </Box>
                    )}
                    {/* ======================================================== */}
                    {/* ===== FIM DO PAINEL DA ABA "CONFIGURAÇÕES GERAIS" ===== */}
                    {/* ======================================================== */}


                    {/* =================================================================== */}
                    {/* ===== INÍCIO DO PAINEL DA ABA "CONFIGURAÇÃO DE ATIVO" (NOVO) ===== */}
                    {/* =================================================================== */}
                    {activeTab === 1 && (
                        <Box sx={{ py: 3 }}>
                            {/* NAVEGAÇÃO DAS SUB-ABAS */}
                            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                                <Tabs value={activeSubTab} onChange={handleSubTabChange} aria-label="configurações de ativo sub-tabs">
                                    <Tab label="Cadastro de Ícone" />
                                    <Tab label="Configuração de Ícone" />
                                </Tabs>
                            </Box>

                            {/* SUB-ABA 1: Cadastro de Ícone */}
                            {activeSubTab === 0 && (
                                <Box>
                                    <Typography variant="h6" gutterBottom>
                                        Cadastro e Edição de Ícones
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                        Cadastre um novo ícone selecionando da biblioteca de ícones ou enviando um SVG personalizado. Para editar, selecione um ícone da lista à direita.
                                    </Typography>

                                    <Grid container spacing={3}>
                                        {/* Coluna do Formulário à esquerda */}
                                        <Grid item xs={12} md={6}>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                <TextField
                                                    fullWidth
                                                    label="Nome do Ícone"
                                                    value={iconName}
                                                    onChange={(e) => setIconName(e.target.value)}
                                                    placeholder="Digite o nome do ícone"
                                                />

                                                <Accordion expanded={expandedAccordion === 'standard'} onChange={handleAccordionChange('standard')}>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                            <Typography>Selecionar Ícone da biblioteca</Typography>
                                                            <Button size="small" onClick={(e) => { e.stopPropagation(); setIconPickerOpen(true); }}>
                                                                Ver Biblioteca
                                                            </Button>
                                                        </Box>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                                                            {standardIcons.map((icon) => {
                                                                const isSelected = iconClass === icon.name;
                                                                const isDisabled = !!svgPreview?.trim();

                                                                return (
                                                                    <Tooltip title={icon.label} key={icon.name}>
                                                                        <Box
                                                                            className="icon-select-box"
                                                                            sx={{
                                                                                border: isSelected ? '2px solid' : '1px solid',
                                                                                borderColor: isSelected ? 'primary.main' : 'divider',
                                                                                borderRadius: 2,
                                                                                p: 1,
                                                                                display: 'flex',
                                                                                flexDirection: 'column',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                width: 60,
                                                                                height: 60,
                                                                                pointerEvents: isDisabled ? 'none' : 'auto',
                                                                                opacity: isDisabled ? 0.5 : 1,
                                                                                cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                                            }}
                                                                            onClick={() => {
                                                                                if (isDisabled) return;
                                                                                if (isSelected) {
                                                                                    setIconClass('');
                                                                                    setIconName('');
                                                                                } else {
                                                                                    setIconName(icon.label);
                                                                                    setSvgPreview('');
                                                                                    setIconClass(icon.name);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <span className="material-icons-outlined" style={{ fontSize: '24px' }}>
                                                                                {icon.name}
                                                                            </span>
                                                                            <Typography variant="caption" sx={{ textAlign: 'center', mt: 0.5 }}>
                                                                                {icon.label}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Tooltip>
                                                                );
                                                            })}
                                                        </Box>
                                                    </AccordionDetails>
                                                </Accordion>

                                                <Accordion expanded={expandedAccordion === 'custom'} onChange={handleAccordionChange('custom')}>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                        <Typography>Usar SVG Personalizado</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                                            Cole o código do seu SVG abaixo. Você pode usar o{' '}
                                                            <a href="https://www.svgrepo.com/" target="_blank" rel="noopener noreferrer">
                                                                SVG Repo Editor
                                                            </a>{' '}
                                                            para criar ou editar.
                                                        </Typography>
                                                        <TextField
                                                            fullWidth
                                                            label="Cole o código SVG aqui"
                                                            multiline
                                                            minRows={3}
                                                            value={svgPreview || ''}
                                                            onChange={(e) => setSvgPreview(e.target.value)}
                                                            placeholder="<svg>...</svg>"
                                                            disabled={!!iconClass}
                                                        />
                                                        {svgPreview && (
                                                            <Box sx={{ mt: 2 }}>
                                                                <Typography variant="subtitle2">Pré-visualização:</Typography>
                                                                <Box
                                                                    sx={{
                                                                        width: 48,
                                                                        height: 48,
                                                                        border: '1px solid',
                                                                        borderColor: 'divider',
                                                                        borderRadius: 1,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        overflow: 'hidden',
                                                                        mt: 1,
                                                                    }}
                                                                    dangerouslySetInnerHTML={{ __html: svgPreview }}
                                                                />
                                                            </Box>
                                                        )}
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Box>
                                        </Grid>

                                        {/* Coluna da Lista de Ícones Cadastrados à direita */}
                                        <Grid item xs={12} md={6}>
                                            <Box sx={{
                                                border: '1px solid',
                                                borderColor: 'divider',
                                                borderRadius: 2,
                                                p: 2,
                                                height: '100%',
                                            }}>
                                                <Typography variant="h6" gutterBottom>
                                                    Ícones Cadastrados
                                                </Typography>
                                                <Box sx={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: 2,
                                                    maxHeight: 400,
                                                    overflowY: 'auto',
                                                    pr: 1
                                                }}>
                                                    {registeredIcons.length === 0 ? (
                                                        <Typography variant="body2" color="text.secondary">
                                                            Nenhum ícone cadastrado para esta organização.
                                                        </Typography>
                                                    ) : (
                                                        registeredIcons.map((icon) => (
                                                            <Box
                                                                key={icon.Id}
                                                                sx={{
                                                                    width: 48,
                                                                    height: 48,
                                                                    p: 0.5,
                                                                    border: selectedIconId === icon.Id ? '2px solid' : '1px solid',
                                                                    borderColor: selectedIconId === icon.Id ? 'primary.main' : 'divider',
                                                                    borderRadius: 2,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    cursor: 'pointer',
                                                                    transition: 'border-color 0.2s',
                                                                    '&:hover': {
                                                                        borderColor: 'primary.light'
                                                                    }
                                                                }}
                                                                onClick={() => {
                                                                    if (selectedIconId === icon.Id) {
                                                                        setIconName('');
                                                                        setSvgPreview('');
                                                                        setSelectedIconId(null);
                                                                        setIconClass('');
                                                                    } else {
                                                                        setIconName(icon.Name || '');
                                                                        setSvgPreview(icon.Value.SVG);
                                                                        setSelectedIconId(icon.Id);
                                                                        setIconClass(icon.Value.Class || '');
                                                                        setExpandedAccordion(icon.Value.SVG ? 'custom' : 'standard');
                                                                    }
                                                                }}
                                                                title={icon.Name}
                                                            >
                                                                {icon.Value?.SVG ? (
                                                                    <span
                                                                        style={{ width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                                        dangerouslySetInnerHTML={{ __html: icon.Value.SVG }}
                                                                    />
                                                                ) : icon.Value?.Class ? (
                                                                    <span
                                                                        className="material-icons-outlined"
                                                                        style={{ fontSize: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}
                                                                    >
                                                                        {icon.Value.Class}
                                                                    </span>
                                                                ) : null}
                                                            </Box>
                                                        ))
                                                    )}
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            )}
                            {/* SUB-ABA 2: Configuração de Ícone */}
                            {activeSubTab === 1 && (
                                <Box>
                                    <Grid container spacing={4}>
                                        {/* Coluna da Tabela de Ativos */}
                                        <Grid item xs={12} md={6}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Ativos da Organização
                                            </Typography>
                                            <AssetSelector
                                                assets={enrichedAssets}

                                                onSelectionChange={handleAssetSelectionChange}
                                                httpClient={httpClient}
                                            />

                                            {assets.length === 0 && !loading && (
                                                <Typography sx={{ mt: 2 }} color="text.secondary">
                                                    Nenhum ativo encontrado para esta organização.
                                                </Typography>
                                            )}
                                        </Grid>

                                        {/* Coluna da Lista de Ícones */}
                                        <Grid item xs={12} md={6}>
                                            <Box sx={{ border: '1px solid #ccc', borderRadius: '8px', p: 2, minHeight: '300px', marginTop: '25px' }}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Ícones Disponíveis
                                                </Typography>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                                                    {registeredIcons.length === 0 && (
                                                        <Typography variant="caption" color="text.secondary">
                                                            Nenhum ícone cadastrado.
                                                        </Typography>
                                                    )}
                                                    {registeredIcons.map((icon) => (
                                                        <Box
                                                            key={icon.Id}
                                                            sx={{
                                                                width: 48,
                                                                height: 48,
                                                                border: selectedIconForAssociation === icon.Id ? '2px solid #1976d2' : '1px solid #ccc',
                                                                borderRadius: 2,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                cursor: 'pointer',
                                                                p: 0.5
                                                            }}
                                                            onClick={() => setSelectedIconForAssociation(icon.Id)}
                                                            title={icon.Name}
                                                        >
                                                            {icon.Value?.SVG ? (
                                                                <span style={{ width: 38, height: 38, display: 'inline-block' }} dangerouslySetInnerHTML={{ __html: icon.Value.SVG }} />
                                                            ) : icon.Value?.Class ? (
                                                                <span
                                                                    className="material-icons-outlined"
                                                                    style={{ fontSize: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}
                                                                >
                                                                    {icon.Value.Class}
                                                                </span>
                                                            ) : null}
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            )}
                        </Box>
                    )}
                    {/* ================================================================= */}
                    {/* ===== FIM DO PAINEL DA ABA "CONFIGURAÇÃO DE ATIVO" (NOVO) ===== */}
                    {/* ================================================================= */}

                    {/* ======================================================================= */}
                    {/* ===== INÍCIO DO PAINEL DA ABA "CONFIGURAÇÃO DOS GATEWAYS" (NOVO) ===== */}
                    {/* ======================================================================= */}
                    {activeTab === 2 && (
                        <Box sx={{ py: 3 }}>
                            {/* NAVEGAÇÃO DAS SUB-ABAS */}
                            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                                <Tabs value={activeSubTab} onChange={handleSubTabChange} aria-label="configuracoes de gateway sub-tabs">
                                    <Tab label="Cadastro de Ícone" />
                                    <Tab label="Configuração de Ícone" />
                                </Tabs>
                            </Box>

                            {/* SUB-ABA 1: Cadastro de Ícone para Gateways */}
                            {activeSubTab === 0 && (
                                <Box>
                                    <Typography variant="h6" gutterBottom>
                                        Cadastro e Edição de Ícones para Gateways
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                        Cadastre um novo ícone para seus gateways. Para editar, selecione um ícone da lista à direita.
                                    </Typography>

                                    <Grid container spacing={3}>
                                        {/* Coluna do Formulário à esquerda (reutilizada) */}
                                        <Grid item xs={12} md={6}>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                <TextField
                                                    fullWidth
                                                    label="Nome do Ícone"
                                                    value={iconName}
                                                    onChange={(e) => setIconName(e.target.value)}
                                                    placeholder="Digite o nome do ícone"
                                                />
                                                <Accordion expanded={expandedAccordion === 'standard'} onChange={handleAccordionChange('standard')}>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                            <Typography>Selecionar Ícone da biblioteca</Typography>
                                                            <Button size="small" onClick={(e) => { e.stopPropagation(); setIconPickerOpen(true); }}>
                                                                Ver Biblioteca
                                                            </Button>
                                                        </Box>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                                                            {standardIcons.map((icon) => {
                                                                const isSelected = iconClass === icon.name;
                                                                const isDisabled = !!svgPreview?.trim();

                                                                return (
                                                                    <Tooltip title={icon.label} key={icon.name}>
                                                                        <Box
                                                                            className="icon-select-box"
                                                                            sx={{
                                                                                border: isSelected ? '2px solid' : '1px solid',
                                                                                borderColor: isSelected ? 'primary.main' : 'divider',
                                                                                borderRadius: 2,
                                                                                p: 1,
                                                                                display: 'flex',
                                                                                flexDirection: 'column',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                width: 60,
                                                                                height: 60,
                                                                                pointerEvents: isDisabled ? 'none' : 'auto',
                                                                                opacity: isDisabled ? 0.5 : 1,
                                                                                cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                                            }}
                                                                            onClick={() => {
                                                                                if (isDisabled) return;
                                                                                if (isSelected) {
                                                                                    setIconClass('');
                                                                                    setIconName('');
                                                                                } else {
                                                                                    setIconName(icon.label);
                                                                                    setSvgPreview('');
                                                                                    setIconClass(icon.name);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <span className="material-icons-outlined" style={{ fontSize: '24px' }}>
                                                                                {icon.name}
                                                                            </span>
                                                                            <Typography variant="caption" sx={{ textAlign: 'center', mt: 0.5 }}>
                                                                                {icon.label}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Tooltip>
                                                                );
                                                            })}
                                                        </Box>
                                                    </AccordionDetails>
                                                </Accordion>

                                                <Accordion expanded={expandedAccordion === 'custom'} onChange={handleAccordionChange('custom')}>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                        <Typography>Usar SVG Personalizado</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                                            Cole o código do seu SVG abaixo. Você pode usar o{' '}
                                                            <a href="https://www.svgrepo.com/" target="_blank" rel="noopener noreferrer">
                                                                SVG Repo Editor
                                                            </a>{' '}
                                                            para criar ou editar.
                                                        </Typography>
                                                        <TextField
                                                            fullWidth
                                                            label="Cole o código SVG aqui"
                                                            multiline
                                                            minRows={3}
                                                            value={svgPreview || ''}
                                                            onChange={(e) => setSvgPreview(e.target.value)}
                                                            placeholder="<svg>...</svg>"
                                                            disabled={!!iconClass}
                                                        />
                                                        {svgPreview && (
                                                            <Box sx={{ mt: 2 }}>
                                                                <Typography variant="subtitle2">Pré-visualização:</Typography>
                                                                <Box
                                                                    sx={{
                                                                        width: 48,
                                                                        height: 48,
                                                                        border: '1px solid',
                                                                        borderColor: 'divider',
                                                                        borderRadius: 1,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        overflow: 'hidden',
                                                                        mt: 1,
                                                                    }}
                                                                    dangerouslySetInnerHTML={{ __html: svgPreview }}
                                                                />
                                                            </Box>
                                                        )}
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Box>
                                        </Grid>
                                        {/* Coluna da Lista de Ícones Cadastrados de Gateway */}
                                        <Grid item xs={12} md={6}>
                                            <Box sx={{
                                                border: '1px solid',
                                                borderColor: 'divider',
                                                borderRadius: 2,
                                                p: 2,
                                                height: '100%',
                                            }}>
                                                <Typography variant="h6" gutterBottom>
                                                    Ícones Cadastrados
                                                </Typography>
                                                <Box sx={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: 2,
                                                    maxHeight: 400,
                                                    overflowY: 'auto',
                                                    pr: 1
                                                }}>
                                                    {registeredGatewayIcons.length === 0 ? (
                                                        <Typography variant="body2" color="text.secondary">
                                                            Nenhum ícone cadastrado para esta organização.
                                                        </Typography>
                                                    ) : (
                                                        registeredGatewayIcons.map((icon) => (
                                                            <Box
                                                                key={icon.Id}
                                                                sx={{
                                                                    width: 48,
                                                                    height: 48,
                                                                    p: 0.5,
                                                                    border: selectedIconId === icon.Id ? '2px solid' : '1px solid',
                                                                    borderColor: selectedIconId === icon.Id ? 'primary.main' : 'divider',
                                                                    borderRadius: 2,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    cursor: 'pointer',
                                                                    transition: 'border-color 0.2s',
                                                                    '&:hover': {
                                                                        borderColor: 'primary.light'
                                                                    }
                                                                }}
                                                                onClick={() => {
                                                                    if (selectedIconId === icon.Id) {
                                                                        setIconName('');
                                                                        setSvgPreview('');
                                                                        setSelectedIconId(null);
                                                                        setIconClass('');
                                                                    } else {
                                                                        setIconName(icon.Name || '');
                                                                        setSvgPreview(icon.Value.SVG);
                                                                        setSelectedIconId(icon.Id);
                                                                        setIconClass(icon.Value.Class || '');
                                                                        setExpandedAccordion(icon.Value.SVG ? 'custom' : 'standard');
                                                                    }
                                                                }}
                                                                title={icon.Name}
                                                            >
                                                                {icon.Value?.SVG ? (
                                                                    <span
                                                                        style={{ width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                                        dangerouslySetInnerHTML={{ __html: icon.Value.SVG }}
                                                                    />
                                                                ) : icon.Value?.Class ? (
                                                                    <span
                                                                        className="material-icons-outlined"
                                                                        style={{ fontSize: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}
                                                                    >
                                                                        {icon.Value.Class}
                                                                    </span>
                                                                ) : null}
                                                            </Box>
                                                        ))
                                                    )}
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            )}

                            {/* SUB-ABA 2: Configuração de Ícone para Gateways */}
                            {activeSubTab === 1 && (
                                <Box>
                                    <Typography variant="h6" gutterBottom>
                                        Associar Ícones aos Gateways
                                    </Typography>
                                    <Grid container spacing={4}>
                                        {/* Coluna do Seletor de Gateways */}
                                        <Grid item xs={12} md={6}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Gateways da Organização
                                            </Typography>
                                            <GatewaySelector
                                                gateways={enrichedGateways}
                                                onSelectionChange={handleGatewaySelectionChange}
                                                httpClient={httpClient}
                                            />
                                            {gateways.length === 0 && !loading && (
                                                <Typography sx={{ mt: 2 }} color="text.secondary">
                                                    Nenhum gateway encontrado para esta organização.
                                                </Typography>
                                            )}
                                        </Grid>

                                        {/* Coluna da Lista de Ícones para Associação */}
                                        <Grid item xs={12} md={6}>
                                            <Box sx={{ border: '1px solid #ccc', borderRadius: '8px', p: 2, minHeight: '300px', marginTop: '25px' }}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Ícones Disponíveis
                                                </Typography>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                                                    {registeredGatewayIcons.length === 0 && (
                                                        <Typography variant="caption" color="text.secondary">
                                                            Nenhum ícone cadastrado.
                                                        </Typography>
                                                    )}
                                                    {registeredGatewayIcons.map((icon) => (
                                                        <Box
                                                            key={icon.Id}
                                                            sx={{
                                                                width: 48,
                                                                height: 48,
                                                                border: selectedIconForGatewayAssociation === icon.Id ? '2px solid #1976d2' : '1px solid #ccc',
                                                                borderRadius: 2,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                cursor: 'pointer',
                                                                p: 0.5
                                                            }}
                                                            onClick={() => setSelectedIconForGatewayAssociation(icon.Id)}
                                                            title={icon.Name}
                                                        >
                                                            {icon.Value?.SVG ? (
                                                                <span style={{ width: 38, height: 38, display: 'inline-block' }} dangerouslySetInnerHTML={{ __html: icon.Value.SVG }} />
                                                            ) : icon.Value?.Class ? (
                                                                <span
                                                                    className="material-icons-outlined"
                                                                    style={{ fontSize: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}
                                                                >
                                                                    {icon.Value.Class}
                                                                </span>
                                                            ) : null}
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            )}
                        </Box>
                    )}
                    {/* ===================================================================== */}
                    {/* ===== FIM DO PAINEL DA ABA "CONFIGURAÇÃO DOS GATEWAYS" (NOVO) ===== */}
                    {/* ===================================================================== */}



                    {/* ======================================================================= */}
                    {/* ===== INÍCIO DO PAINEL DA ABA "CONFIGURAÇÃO DE LOCAIS" (NOVO) ===== */}
                    {/* ======================================================================= */}
                    {activeTab === 3 && (
                        <Box sx={{ py: 3 }}>
                            <Typography variant="h6" gutterBottom>
                                {selectedPerimetroId ? `Editando Perímetro` : "Cadastrar Novo Perímetro"}
                            </Typography>
                            <Grid container spacing={3}>
                                {/* Coluna de Seleção e Input */}
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth sx={{ mb: 2 }}>
                                        <InputLabel id="select-local-label">Selecione um Local *</InputLabel>
                                        <Select
                                            labelId="select-local-label"
                                            value={selectedLocalId}
                                            label="Selecione um Local *"
                                            onChange={(e: SelectChangeEvent<string | number>) => {
                                                setSelectedLocalId(e.target.value);
                                                // Ao mudar o local, limpamos a seleção de perímetro,
                                                // pois ele pertencia ao local antigo.
                                                // O useEffect [selectedLocalId] buscará os novos perímetros.
                                                handleLimparFormulario();
                                                setSelectedLocalId(e.target.value); // Seta o novo local
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>(Exibir perímetros de TODOS os locais)</em>
                                            </MenuItem>
                                            {locais.length === 0 && (
                                                <MenuItem value="" disabled>
                                                    {loading ? "Carregando locais..." : "Nenhum local encontrado"}
                                                </MenuItem>
                                            )}
                                            {locais.map((local) => (
                                                <MenuItem key={local.Id} value={local.Id}>
                                                    {local.Name} (ID: {local.Id})
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    <TextField
                                        fullWidth
                                        label="Nome do Perímetro *"
                                        value={nomePerimetro}
                                        onChange={(e) => setNomePerimetro(e.target.value)}
                                        placeholder="Ex: Fazenda - Sede"
                                        sx={{ mb: 2 }}
                                    />

                                    <TextField
                                        fullWidth
                                        label="Cole o GeoJSON do perímetro aqui *"
                                        multiline
                                        minRows={10} // Mantém a altura mínima
                                        maxRows={10} // Define a altura máxima igual à mínima (ou ajuste conforme preferir)
                                        value={geoJsonString}
                                        onChange={(e) => setGeoJsonString(e.target.value)}
                                        placeholder='{ "type": "FeatureCollection", "features": [{ "type": "Feature", "geometry": { ... } }] }' // Placeholder atualizado
                                        error={geoJsonString.length > 0 && !parsedGeoJson}
                                        helperText={
                                            geoJsonString.length > 0 && !parsedGeoJson ? (
                                                "GeoJSON inválido" // Mensagem de erro simples
                                            ) : (
                                                <> {/* Usa um React Fragment para agrupar texto e link */}
                                                    Cole uma FeatureCollection, Feature ou Geometria (Polygon/MultiPolygon), acesse o link a seguir para gerar o GeoJson:{' '}
                                                    <a href="https://geojson.io/" target="_blank" rel="noopener noreferrer">
                                                        https://geojson.io/
                                                    </a>
                                                </>
                                            )
                                        }
                                        sx={{
                                            mb: 2,
                                            '& .MuiInputBase-input': {
                                                overflow: 'auto !important',
                                                maxHeight: '250px',
                                            },
                                        }}
                                    />

                                    <Box sx={{ display: 'flex', gap: 2, mt: 3, flexWrap: 'wrap' }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleCreatePerimetro}
                                            disabled={loading || !!selectedPerimetroId || !selectedLocalId || !parsedGeoJson || !nomePerimetro}
                                        >
                                            Cadastrar Novo
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={handleUpdatePerimetro}
                                            disabled={loading || !selectedPerimetroId || !selectedLocalId || !parsedGeoJson || !nomePerimetro}
                                        >
                                            Atualizar
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            color="error"
                                            onClick={handleDeletePerimetro}
                                            disabled={loading || !selectedPerimetroId}
                                        >
                                            Deletar
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            color="inherit"
                                            onClick={handleLimparFormulario}
                                            disabled={loading}
                                            sx={{ ml: 'auto' }} // Joga para a direita
                                        >
                                            Limpar Seleção
                                        </Button>
                                    </Box>

                                </Grid>

                                {/* Coluna do Mapa */}
                                <Grid item xs={12} md={6}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Visualização
                                    </Typography>
                                    <Box sx={{ height: '480px', width: '100%', border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' }}>
                                        <MapContainer center={mapCenter} zoom={13} style={{ height: '100%', width: '100%' }} key={mapCenter.toString()}>
                                            <TileLayer
                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                            />

                                            {/* Camada 1: Perímetros Cadastrados (Azul, clicável) */}
                                            {perimetrosFeatureCollection.features.length > 0 && (
                                                <GeoJSON
                                                    key={perimetrosCadastrados.map(p => p.Id).join('-')} // Força remonte se os IDs mudarem
                                                    data={perimetrosFeatureCollection as any} // 'as any' para contornar tipo
                                                    style={{ color: '#007bff', weight: 3, opacity: 0.7 }}
                                                    onEachFeature={onEachPerimetro} // Adiciona eventos
                                                />
                                            )}

                                            {/* Camada 2: Perímetro em Edição (Vermelho, preview) */}
                                            {parsedGeoJson && (
                                                <GeoJSON
                                                    key={geoJsonString} // Força remonte se o texto mudar
                                                    data={parsedGeoJson}
                                                    style={{ color: '#ff0000', weight: 2, fillOpacity: 0.3 }}
                                                />
                                            )}
                                            <MapBoundsAdjuster
                                                perimetros={perimetrosCadastrados}
                                                selectedPerimetroId={selectedPerimetroId}
                                                initialCenter={mapInitialCenter}
                                                initialZoom={initialZoom}
                                            />
                                        </MapContainer>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    )}
                    {/* ===================================================================== */}
                    {/* ===== FIM DO PAINEL DA ABA "CONFIGURAÇÃO DE LOCAIS" (NOVO) ===== */}
                    {/* ===================================================================== */}



                </CardContent>

            </Card>
            <IconPicker
                open={isIconPickerOpen}
                onClose={() => setIconPickerOpen(false)}
                onSelect={handleIconSelectFromPicker}
            />
        </Box>
    );
};

export default EditarOrganizacao;